export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";